import { Button as OriginalButton } from 'antd-mobile';
import { withNativeElementWrap } from '../../utils/hoc';
export default withNativeElementWrap(OriginalButton, ['clear'], ['onClick']);
